<div fxLayout="column" fxFlex="1 0 auto">
  <div fxLayout="column" class="neq-page-wrapper">
    <div fxLayout="row">
      <div fxLayoutAlign="start center" class="neq-action-button">
        <button
          pButton
          class="neq-primeng-button primeng-flat"
          (click)="resetFilter()"
          [matTooltip]="'msg.common.icon.filter.reset' | translate"
        >
          <neq-icon svgIcon="filter-slash"></neq-icon>
        </button>
        <mat-checkbox (change)="displayArchivedSamples()">{{ 'msg.common.icon.sample.display-archived' | translate }}</mat-checkbox>
        <div *ngIf="advanceSearchCriterias" fxLayoutAlign="start end" class="advanced-search-result-div">
          <div fxLayout="row" fxLayout="start center" fxLayoutGap="0.714rem">
            <div>{{ 'label.user.sample.list.advanced-search-result' | translate }}</div>
            <div><em (click)="leaveAdvancedSearchResult()" (keyDown)="leaveAdvancedSearchResult()" class="fas fa-times"></em></div>
          </div>
        </div>
      </div>
      <div fxLayoutAlign="end center" class="neq-action-button" style="margin-left: auto;">
        <button pButton class="neq-primeng-button primeng-flat"
                routerLink="/app/samples/create"
                [matTooltip]="'msg.common.icon.sample.create' | translate"
        >
          <neq-icon svgIcon="plus"></neq-icon>
        </button>

        <button pButton *ngIf="canSelectMulipleSamples()"
          class="neq-primeng-button primeng-flat"  style="margin-left: 15px;"
          [matTooltip]="'msg.common.icon.rawmaterial.multiselection' | translate"
          (click)="onClickMultiselection()"
          [disabled]="!canUseMultiselection()"
        >
          <neq-icon svgIcon="list-check"></neq-icon>
        </button>
      </div>
    </div>
    <neq-table
      *ngIf="showTable"
      [sessionId]="sessionIdOfTable"
      [selectableRows]="canSelectMulipleSamples"
      [disableSelectableCell]="disableSampleSelection"
      [activeFilter]="true"
      [cols]="cols"
      [onRequestData]="refreshTable"
      [rowClass]="calculateRowCssClass"
      fxFlex
    >
    </neq-table>
  </div>
</div>
